import { render, staticRenderFns } from "./PermissionsValidator.vue?vue&type=template&id=bddd90ac&scoped=true&"
import script from "./PermissionsValidator.vue?vue&type=script&lang=ts&"
export * from "./PermissionsValidator.vue?vue&type=script&lang=ts&"
import style0 from "./PermissionsValidator.vue?vue&type=style&index=0&id=bddd90ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bddd90ac",
  null
  
)

export default component.exports